import { useQueryClient, useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { updateFormulaOrder } from '../service/formulaService'
import { Formula } from '../types/Formula'
import formulaQueryKeys from './formulaQueryKeys'
import { showSuccessMessage } from '../../../utils/message'

export const useUpdateFormulaOrder = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['budget', 'formula', 'updateOrder'],
    mutationFn: (data: Partial<Formula>[]) => updateFormulaOrder(data, companyId),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: formulaQueryKeys.list({ companyId }) })
      showSuccessMessage()
    }
  })
}
